// src/cpq_agent/webchat_ui/agent-finalize-helpers.js
//
// Pure, dependency-FREE helpers for the finalize path. Kept import-free on
// purpose so they stay unit-testable in plain node: importing agent-activity.js
// pulls the full render chain (agent-activity.js -> auth.js -> connection-delete.js),
// and some of those modules run document/window code at load time, which throws
// outside a browser. Keeping the decision logic here lets the unit test import
// just this file.

/**
 * Decide whether finalizeArtifacts should render payload.summary as the answer.
 *
 * Streamed message_delta events fold into type:"text" parts; when at least one
 * carries non-empty prose, THAT is the answer and re-rendering the summary would
 * double it. Only when no streamed text part exists AND the summary is
 * meaningful (a non-empty string other than the "Done" placeholder) do we fall
 * back to rendering the summary so a backend that emits agent_final with a
 * summary but ZERO text deltas still shows an answer.
 *
 * @param {Array}  parts   — the finalized parts array
 * @param {string} summary — payload.summary
 * @returns {boolean}
 */
export function shouldRenderSummaryFallback(parts, summary) {
  if (typeof summary !== "string") return false;
  const s = summary.trim();
  if (!s || s === "Done") return false;
  const hasStreamedText = (parts || []).some(
    (p) => p && p.type === "text" && typeof p.md === "string" && p.md.trim() !== "");
  return !hasStreamedText;
}
